// We want these to match the API schema as closely as possible

import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

export const anthropicJsonSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    max_tokens: {
      type: 'integer',
      description: 'The maximum number of tokens to generate before stopping.',
      minimum: 1,
    },
    metadata: {
      type: 'object',
      description: 'Metadata about the request.',
    },
    stop_sequences: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'Custom text sequences that will cause the model to stop generating.',
    },
    stream: {
      type: 'boolean',
      description: 'Whether to incrementally stream the response using server-sent events.',
    },
    temperature: {
      type: 'number',
      description: 'Amount of randomness injected into the response.',
      minimum: 0.0,
      maximum: 1.0,
    },
    tool_choice: {
      type: 'object',
      properties: {
        tool: {
          type: 'string',
          description: 'How the model should use the provided tools.',
        },
      },
    },
    tools: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            description: 'Name of the tool.',
          },
          description: {
            type: 'string',
            description: 'Description of the tool.',
          },
          input_schema: {
            type: 'object',
            description: 'JSON schema for the tool input.',
          },
        },
        required: ['name'],
      },
    },
    top_k: {
      type: 'integer',
      description: 'Sample from the top K options for each subsequent token.',
    },
    top_p: {
      type: 'number',
      description: 'Use nucleus sampling to control token generation.',
    },
    effort: {
      type: 'string',
      description:
        'Control how many tokens Claude uses when responding, trading off between response thoroughness and token efficiency.',
      enum: ['max', 'high', 'medium', 'low'],
    },
  },
  required: ['model', 'messages', 'max_tokens'],
} as const;

// this confirms that the type is a valid JSON schema, but we want it as a `const` so we can use it to index the properties
export const anthropicSchemaProperties: DeepReadonly<JSONSchema7> = anthropicJsonSchema;

export const retrieveAnthropicParameters = (): string[] => Object.keys(anthropicJsonSchema.properties);
